import Vue from "vue";
import Router from "vue-router";
import { Message } from "element-ui";
import MainLayout from "../layouts/MainLayout.vue";
import Login from "../views/Login.vue";
import Home from "../views/dashboard/Home.vue";
import PersonnelList from "../views/personnel/PersonnelList.vue";
import PersonnelDetail from "../views/personnel/PersonnelDetail.vue";
import CustomerLedger from "../views/customers/CustomerLedger.vue";
import CustomerConversationDetail from "../views/customers/CustomerConversationDetail.vue";
import LeadLedger from "../views/leads/LeadLedger.vue";
import Settings from "../views/settings/Settings.vue";
import Monitor from "../views/monitor/Monitor.vue";
import DepartmentManagement from "../views/departments/DepartmentManagement.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/login", component: Login, meta: { public: true, title: "登录" } },
    {
      path: "/",
      component: MainLayout,
      redirect: () => getDefaultAuthedPath(),
      children: [
        { path: "home", component: Home, meta: { title: "首页" } },
        { path: "personnel", component: PersonnelList, meta: { title: "人员管理" } },
        { path: "personnel/:id", component: PersonnelDetail, meta: { title: "人员详情" } },
        { path: "customers", component: CustomerLedger, meta: { title: "客户列表" } },
        { path: "departments", component: DepartmentManagement, meta: { title: "部门管理", requiresAdmin: true } },
        { path: "leads", component: LeadLedger, meta: { title: "线索列表", requiresLeadAccess: true } },
        { path: "customers/:id/conversation", component: CustomerConversationDetail, meta: { title: "对话详情" } },
        { path: "media-library", component: Settings, meta: { title: "图片素材库", requiresMediaLibraryAccess: true } },
        { path: "settings", component: Settings, meta: { title: "系统设置", requiresAdmin: true } },
        { path: "monitor", component: Monitor, meta: { title: "监控中心" } }
      ]
    },
    { path: "*", redirect: () => getDefaultAuthedPath() }
  ]
});

function isAdminUser() {
  if (localStorage.getItem("is_admin") === "1") return true;
  const username = String(localStorage.getItem("username") || "").trim();
  if (username === "吴强") return true;
  const normalizedUsername = username.toLowerCase();
  if (normalizedUsername === "admin@mianzhi.com" || normalizedUsername === "admin") return true;
  try {
    const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
    if (Number(user?.is_admin) === 1 || user?.is_admin === true) return true;
    return String(user?.name || "").trim() === "吴强";
  } catch (e) {
    return false;
  }
}

function hasLeadAccess() {
  if (isAdminUser()) return true;
  return isLeadOnlyUser();
}

function isWuQiangUser() {
  const username = String(localStorage.getItem("username") || "").trim();
  if (username === "吴强") return true;
  try {
    const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
    return String(user?.name || "").trim() === "吴强";
  } catch (e) {
    return false;
  }
}

function canViewMediaLibrary() {
  if (isAdminUser()) return true;
  return isWuQiangUser();
}

function getDefaultAuthedPath() {
  if (isLeadOnlyUser()) return "/leads";
  if (isAdminUser()) return "/departments";
  return "/home";
}

function isLeadOnlyUser() {
  if (isAdminUser()) return false;
  const username = String(localStorage.getItem("username") || "").trim();
  if (username === "储昌宏") return true;
  try {
    const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
    return String(user?.name || "").trim() === "储昌宏";
  } catch (e) {
    return false;
  }
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (!to.meta.public && !token) return next("/login");
  if (to.path === "/login" && token) {
    return next(getDefaultAuthedPath());
  }

  if (isLeadOnlyUser() && to.path !== "/leads") {
    if (to.path !== "/login") {
      Message.warning("当前账号仅可访问线索列表");
    }
    return next("/leads");
  }

  if (to.matched.some((record) => record.meta && record.meta.requiresAdmin) && !isAdminUser()) {
    Message.warning("仅管理员可访问系统管理");
    return next("/home");
  }
  if (to.matched.some((record) => record.meta && record.meta.requiresLeadAccess) && !hasLeadAccess()) {
    Message.warning("仅储昌宏和管理员可访问线索列表");
    return next("/home");
  }
  if (to.matched.some((record) => record.meta && record.meta.requiresMediaLibraryAccess) && !canViewMediaLibrary()) {
    Message.warning("仅管理员和吴强可访问图片素材库");
    return next("/home");
  }

  next();
});

export default router;
